import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=6b50d6aa&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"
import style0 from "./VersionList.vue?vue&type=style&index=0&id=6b50d6aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50d6aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b50d6aa')) {
      api.createRecord('6b50d6aa', component.options)
    } else {
      api.reload('6b50d6aa', component.options)
    }
    module.hot.accept("./VersionList.vue?vue&type=template&id=6b50d6aa&scoped=true", function () {
      api.rerender('6b50d6aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/VersionList.vue"
export default component.exports